const Inst_Dahsboard = () =>
    import ('@/components/Instructor/Instructor_Dashboard/InstructorDashboard');
const Inst_Course = () =>
    import ('@/components/Instructor/Instructor_Dashboard/MyCourse');
const  Notification = () => import ('@/components/Instructor/Notification');
const Messages = () => import ('@/components/Instructor/Messages');
const Instructor = () =>
    import ('@/components/Instructor/Instructor');
const QuizMenu = () =>
    import ('@/components/Instructor/Quiz/QuizMenu');
const QuestionBank = () =>
    import ('@/components/Instructor/Quiz/QuestionBank');
const StudentTestSummary = () =>
    import ('@/components/Instructor/Quiz/StudentTestSummary');
const EditQuestionBank = () =>
    import ('@/components/Instructor/Quiz/EditQuestionBank');
const QuizScheduling = () =>
    import ('@/components/Instructor/Quiz/QuizScheduling');
const Lectures_Webinar = () =>
    import ('@/components/Instructor/InstructorCourseData/lectures_webinar');
const FilesUpload = () =>
    import ('@/components/Instructor/InstructorCourseData/FilesUpload');
const UploadFile = () =>
    import ('@/components/Instructor/InstructorCourseData/UploadFile');
const UploadLink = () =>
    import ('@/components/Instructor/InstructorCourseData/UploadLink');
const AddQuestionOption = () =>
    import ('@/components/Instructor/Quiz/AddQuestionOption')
const QuizResponses = () =>
    import ('@/components/Instructor/Quiz/QuizResponses');
const ViewResponses = () =>
    import ('@/components/Instructor/Quiz/ViewResponses');
const Inst_CreateCourse = () =>
    import ('@/components/Instructor/InstructorCourseDashboard/CreateCourse');
const Inst_Collaborate = () =>
    import ('@/components/Instructor/InstructorCourseDashboard/Collaborate');
const Announcement = () =>
    import ('@/components/Instructor/Instructor_Dashboard/AnnouncementsNotices');
const Discussions = () =>
    import ('@/components/Instructor/Instructor_Dashboard/Discussions');
const RulesPaths = () =>
    import ('@/components/Instructor/Instructor_Dashboard/Rules&Paths');
const InstructorCourseData = () =>
    import ('@/components/Instructor/InstructorCourseData/Instructor_Course_Data');
const CourseBasicInfo = () =>
    import ('@/components/Instructor/InstructorCourseData/CourseBasicInfo');
const Syllabus = () =>
    import ('@/components/Instructor/Syllabus/Syllabus');
const CourseContent = () =>
    import ('@/components/Instructor/CourseContent/CourseContent');
const CourseContentVideo = () =>
    import ('@/components/MediaPlayer/VideoPlayer');    
const Video = () =>
    import ('@/components/Instructor/CourseContent/Video');    
const Material = () =>
    import ('@/components/Instructor/CourseContent/Material');     
const Assignment = () =>
    import ('@/components/Instructor/CourseContent/Assignment');      
const UsefullLinks = () =>
    import ('@/components/Instructor/CourseContent/UsefullLinks');    
const Profile = () =>
    import ('@/components/Instructor/InstructorProfile');
const EditInstructorProfile = () =>
    import ('@/components/Instructor/EditInstructorProfile');
const courseanalytics = () =>
    import ('@/components/Instructor/learnerProgress/courseanalytics');
const courselearners = () =>
    import ('@/components/Instructor/learnerProgress/courselearners');
const Enrolllearners = () =>
    import ('@/components/Instructor/learnerProgress/Enrolllearners');
const Infographics = () =>
    import ('@/components/Instructor/learnerProgress/Infographics');
const learnerProgressMenu = () =>
    import ('@/components/Instructor/learnerProgress/learnerProgressMenu');
const WebinarTools = () =>
    import ('@/components/Instructor/InstructorCourseData/Webinar-Tools');
const CourseAssessment = () =>
    import ('@/components/Instructor/InstructorCourseData/CourseAssessment');
const MCQ = () => import ('@/components/Instructor/CourseContent/MCQ');
const ViewMCQAssignment = () =>     
    import ('@/components/Instructor/CourseContent/ViewMCQAssignment'); 
const ViewProjectAssignment = () =>     
    import ('@/components/Instructor/CourseContent/ViewProjectAssignment');
    const ViewCieAssignment = () =>     
    import ('@/components/Instructor/CourseContent/ViewCieAssignment'); 
const EditMCQAssignment = () =>     
    import ('@/components/Instructor/CourseContent/EditMCQAssignment'); 
const SingleWordAnswer = () =>     
    import ('@/components/Instructor/CourseContent/SingleWordAnswer'); 
const SingleWordAnswerEdit = () =>     
    import ('@/components/Instructor/CourseContent/SingleWordAnswerEdit'); 
const ViewSingleWordAnswer = () =>     
    import ('@/components/Instructor/CourseContent/ViewSingleWordAnswer'); 
       
const CourseAssessmentEvaluate = () => 
    import('@/components/Instructor/InstructorCourseData/CourseAssessmentEvaluate')
const   CourseAssessmentEvaluate02 = () => 
import('@/components/Instructor/InstructorCourseData/CourseAssessmentEvaluate02')
const MyCalendar = () =>
    import ('@/components/Instructor/InstructorCalendar/MyCalendar'); 
const Surveys = () =>
    import ('@/components/Instructor/Survey/Surveys'); 
const AddSurvey = () =>
    import ('@/components/Instructor/Survey/AddSurvey'); 
const AddSurveyQuestion = () =>
    import ('@/components/Instructor/Survey/AddSurveyQuestion'); 
const SelectSurveyQuestions = () =>
    import ('@/components/Instructor/Survey/SelectSurveyQuestions'); 
const SurveyResponses = () =>
    import ('@/components/Instructor/Survey/SurveyResponses'); 
const Editsurveyquestion = () =>
    import ('@/components/Instructor/Survey/Editsurveyquestion');
const VideoTraining = () =>
    import ('@/components/Instructor/VideoTraining'); 
const ArchiveCourse = () =>
    import ('@/components/Instructor/ArchiveCourse');
const ArchiveCourseDetails = () =>
    import ('@/components/Instructor/ArchiveCourseDetails');
const Reports = () =>
    import ('@/components/Instructor/Reports/Reports');
// const ArchiveCourse = () =>
//     import ('@/components/Instructor/InstructorCourseData/ArchiveCourse');
// const ArchiveCourseDetails = () =>
//     import ('@/components/Instructor/InstructorCourseData/ArchiveCourseDetails');
const Evaluation = () =>import ('@/components/Instructor/Evaluation/Evaluation'); 
const Platformfeedback = () =>import ('@/components/Instructor/Platformfeedback'); 
const ContactSupport = () => import('@/components/Instructor/ContactSupport');
    // const MyCalendar = () =>
    // import ('@/components/Instructor/InstructorCalendar/MyCalendar'); 

    const routes = [{
    path: '/instructor',
    name: 'instructor',
    component: Instructor,
    meta: { breadcrumb: 'Dashboard' },
    props: true,
    children: [{
            path: 'inst-dashboard',
            name: 'inst-dashboard',
            component: Inst_Dahsboard,
            meta: { breadcrumb: '' },
        },
        {
            path: '/inst-my-course',
            name: 'inst-my-course',
            component: Inst_Course,
            meta: { breadcrumb: 'My Course' },
            children: [{
                path: '/inst-course-data',
                name: 'inst-course-data',
                //meta: { breadcrumb: router => `${router.id}` },
                component: InstructorCourseData,
                children: [{
                        path: '/course-basic-info',
                        name: 'course-basic-info',
                        meta: { breadcrumb: router => `${router.id} / Basic Info.` },
                        component: CourseBasicInfo,
                    },
                    {
                        path: '/syllabus',
                        name: 'syllabus',
                        meta: { breadcrumb: router => `${router.id} / Syllabus` },
                        component: Syllabus,
                    },
                    {
                        path: '/inst-course-content',
                        name: 'inst-course-content',
                        meta: { breadcrumb: router => `${router.id} / Course Content` },
                        component: CourseContent,
                    },
                    {
                        path: '/inst-course-content-video',
                        name: 'inst-course-content-video',
                        meta: { breadcrumb: router => `${router.id} / Course Content [Video]` },
                        component: Video,
                        children:[
                            {
                                path: '/inst-course-content-video-player/:id',
                                name: 'inst-course-content-video-player',
                                component: CourseContentVideo,
                            }
                        ]
                    },
                    {
                        path: '/inst-course-content-material',
                        name: 'inst-course-content-material',
                        meta: { breadcrumb: router => `${router.id} / Course Content [Material]` },
                        component: Material,
                    },
                    {
                        path: '/inst-course-content-assignment',
                        name: 'inst-course-content-assignment',
                        meta: { breadcrumb: router => `${router.id} / Course Content [Assignment]` },
                        component: Assignment,
                    },
                    {
                        path: '/inst-course-content-usefull-links',
                        name: 'inst-course-content-usefull-links',
                        meta: { breadcrumb: router => `${router.id} / Course Content [Usefull Links]` },
                        component: UsefullLinks,
                    },
                    {
                        path: '/inst-course-content-mcqassignment',
                        name: 'inst-course-content-mcqassignment',
                        meta: { breadcrumb: router => `${router.id} /Mcq Assignment` },
                        component: MCQ,
                    },
                    {
                        path: '/inst-course-content-viewmcqassignment',
                        name: 'inst-course-content-viewmcqassignment',
                        meta: { breadcrumb: router => `${router.id} / View Mcq Assignment` },
                        component: ViewMCQAssignment,
                    },
                    {
                        path: '/inst-course-content-viewprojectassignment',
                        name: 'inst-course-content-viewprojectassignment',
                        meta: { breadcrumb: router => `${router.id} / View Peoject Assignment` },
                        component: ViewProjectAssignment,
                    },
                    {
                        path: '/inst-course-content-viewcieassignment',
                        name: 'inst-course-content-viewcieassignment',
                        meta: { breadcrumb: router => `${router.id} / View Cie Assignment` },
                        component: ViewCieAssignment,
                    },
                    {
                        path: '/inst-course-content-editmcqassignment',
                        name: 'inst-course-content-editmcqassignment',
                        meta: { breadcrumb: router => `${router.id} / Edit Mcq Assignment` },
                        component: EditMCQAssignment,
                    },
                    {
                        path: '/inst-course-content-singlewordqassignment',
                        name: 'inst-course-content-singlewordqassignment',
                        meta: { breadcrumb: router => `${router.id} / Single Word Assignment` },
                        component: SingleWordAnswer,
                    },
                    {
                        path: '/inst-course-content-editsinglewordqassignment',
                        name: 'inst-course-content-editsinglewordqassignment',
                        meta: { breadcrumb: router => `${router.id} / Edit Single Word Assignment` },
                        component: SingleWordAnswerEdit,
                    },
                    {
                        path: '/inst-course-content-viewsinglewordqassignment',
                        name: 'inst-course-content-viewsinglewordqassignment',
                        meta: { breadcrumb: router => `${router.id} / View Single Word Assignment` },
                        component: ViewSingleWordAnswer,
                    },
                    {
                        path: '/quiz-menu',
                        name: 'quiz-menu',
                        component: QuizMenu,
                        meta: { breadcrumb: router => `${router.id} / Test/Quiz` },
                        // meta: { breadcrumb: 'Test/Quiz' },
                    },
                    {
                        path: '/create-question-bank',
                        name: 'create-question-bank',
                        component: QuestionBank,
                        meta: { breadcrumb: router => `${router.id} / Test/Quiz / Question Bank` },
                        // meta: { breadcrumb: 'Test/Quiz / Question Bank' },
                    },
                    {
                        path: '/student-test-summary',
                        name: 'student-test-summary',
                        component: StudentTestSummary,
                        meta: { breadcrumb: router => `${router.id} / Test/Quiz / Student Test Summary` },
                    },
                    {
                        path: '/add-question-bank',
                        name: 'add-question-bank',
                        component: AddQuestionOption,
                        meta: { breadcrumb: router => `Test/Quiz / Question Bank` },
                    },
                    {
                        path: '/edit-question-bank',
                        name: 'edit-question-bank',
                        component: EditQuestionBank,
                        meta: { breadcrumb: router => `${router.id} / Test/Quiz / Question Bank` },
                    },
                    {
                        path: '/quiz-scheduling',
                        name: 'quiz-scheduling',
                        component: QuizScheduling,
                        meta: { breadcrumb: 'Test/Quiz / Quiz Scheduling' },
                    },
                    {
                        path: '/lectures_webinar',
                        name: 'lectures_webinar',
                        component: Lectures_Webinar,
                        meta: { breadcrumb: router => `${router.id} / Lectures&Webinars` },
                    },
                    {
                        path: '/files-upload',
                        name: 'files-upload',
                        component: FilesUpload,
                        meta: { breadcrumb: router => `${router.id} /Files Upload` },
                    },
                    {
                        path: '/upload-file',
                        name: 'upload-file',
                        component: UploadFile,
                        meta: { breadcrumb: `File Upload` },
                    },
                    {
                        path: '/upload-link',
                        name: 'upload-link',
                        component: UploadLink,
                        meta: { breadcrumb: `File Link` },
                    },
                    {
                        path: '/quiz-responses',
                        name: 'quiz-responses',
                        component: QuizResponses,
                        meta: { breadcrumb: 'Test/Quiz / Quiz Responses' },
                    },
                    {
                        path: '/view-responses',
                        name: 'view-responses',
                        component: ViewResponses,
                        meta: { breadcrumb: 'Test/Quiz / View Responses' },
                    },
                    {
                        path: '/course-analytics',
                        name: 'course-analytics',
                        component: courseanalytics,
                        meta: { breadcrumb: `Learner Progress / Course Analytics` },
                    },
                    {
                        path: '/course-learners',
                        name: 'course-learners',
                        component: courselearners,
                        meta: { breadcrumb: `Learner Progress / Course Learners` },
                    },
                    {
                        path: '/enroll-learners',
                        name: 'enroll-learners',
                        component: Enrolllearners,
                        meta: { breadcrumb: `Learner Progress / Enroll Learners` },
                    },
                    {
                        path: '/infographics',
                        name: 'infographics',
                        component: Infographics,
                        meta: { breadcrumb: `Learner Progress / infographics` },
                    },
                    {
                        path: '/learner-progress-menu',
                        name: 'learner-progress-menu',
                        component: learnerProgressMenu,
                    },
                    {
                        path: '/webinar-tools',
                        name: 'webinar-tools',
                        component: WebinarTools,
                        meta: { breadcrumb: router => `${router.id} / Lectures&Webinars/` },
                    },
                    {
                        path: '/course-assessment',
                        name: 'course-assessment',
                        component: CourseAssessment,
                        meta: { breadcrumb: router => `${router.id} / CourseAssessment/` },
                    },
                    {
                        path: '/course-evaluation',
                        name: 'course-evaluation',
                        component: Evaluation,
                        meta: { breadcrumb: router => `${router.id} / Evaluation/` },
                    },
                    {
                        path: '/course-assessment-evaluate',
                        name: 'course-assessment-evaluate',
                        component: CourseAssessmentEvaluate,
                        meta: { breadcrumb: router => `${router.id} / CourseAssessment/Course Assessment Evaluate` },
                    },
                    {
                        path: '/course-assessment-evaluate-ass',
                        name: 'course-assessment-evaluate-ass',
                        component: CourseAssessmentEvaluate02,
                        meta: { breadcrumb: router => `${router.id} / CourseAssessment/Course Assessment Evaluate` },
                    },
                    {
                        path: '/inst-discussions',
                        name: 'inst-discussions',
                        component: Discussions,
                        meta: { breadcrumb: router => `${router.id} / Discussions` },
                    },
                    {
                        path: '/course-rules&paths',
                        name: 'course-rules&paths',
                        component: RulesPaths,
                        meta: { breadcrumb: router => `${router.id} / Discussions` },
                    },
                    {
                        path: '/reports',
                        name: 'reports',
                        component: Reports,
                        meta: { breadcrumb: router => `${router.id} / Reports` },
                    },
                    {
                        path: '/platform-feedback-instructor',
                        name: 'platform-feedback-instructor',
                        //meta: { breadcrumb: router => `${router.id}},
                        component: Platformfeedback,
                    },

                ]
            }, ]
        },
        {
            path: 'create-course',
            name: 'create-course',
            meta: { breadcrumb: 'Create Course' },
            component: Inst_CreateCourse,
        },
        {
            path: '/contact-support',
            name: 'contact-support',
            component: ContactSupport,
            meta: { breadcrumb: router =>`Contact Support` },

          },
        {
            path: 'video-training',
            name: 'video-training',
            meta: { breadcrumb: 'Video Training' },
            component: VideoTraining,
        },
        {
            path: '/instructor-notification',
            name: 'instructor-notification',
            component: Notification
        },
        {
            path: '/instructor-messages',
            name: 'instructor-messages',
            component: Messages
        },
        {
            path: 'archive-course',
            name: 'archive-course',
            meta: { breadcrumb: 'Archive Course' },
            component: ArchiveCourse,
        },
        {
            path: 'archive-course-details',
            name: 'archive-course-details',
            meta: { breadcrumb: 'Archive Course Details' },
            component: ArchiveCourseDetails,
        },
        {
            path: 'collaborate',
            name: 'collaborate',
            meta: { breadcrumb: 'My Collborators' },
            component: Inst_Collaborate,
        },
        {
            path: '/inst-profile',
            name: 'inst-profile',
            meta: { breadcrumb: 'Profile' },
            component: Profile,
        },
        {
            path: '/inst-edit-profile',
            name: 'inst-edit-profile',
            meta: { breadcrumb: 'Edit-Profile' },
            component: EditInstructorProfile,
        },
        {
            path: '/announcement',
            name: 'instructor-announcement-notices',
            component: Announcement,
            meta: { breadcrumb: 'Announcements & Notices' },
        },
        {
            path: '/instructor-calendar',
            name: 'instructor-mycalendar-events',
            component: MyCalendar,
            meta: { breadcrumb: 'MyCalendar' },
        },
        {
            path: '/instructor-surveys',
            name: 'instructor-surveys',
            component: Surveys,
            meta: { breadcrumb: 'Survey' },
        },
        {
            path: '/add-surveys',
            name: 'add-surveys',
            component: AddSurvey,
            meta: { breadcrumb: 'Survey / Add Survey' },
        },
        {
            path: '/add-surveys-questions',
            name: 'add-surveys-questions',
            component: AddSurveyQuestion,
            meta: { breadcrumb: 'Survey / Add Survey Question' },
        },
        {
            path: '/select-surveys-questions',
            name: 'select-surveys-questions',
            component: SelectSurveyQuestions,
            meta: { breadcrumb: 'Survey / Select Survey Question' },
        },
        {
            path: '/surveys-responses',
            name: 'surveys-responses',
            component: SurveyResponses,
            meta: { breadcrumb: 'Survey / Survey Responses' },
        },
        {
            path: '/edit-survey-question',
            name: 'edit-survey-question',
            component: Editsurveyquestion,
            meta: { breadcrumb: 'Survey / Survey Responses' },
        },

    ]
}, ]
export default routes